/*

? The reasons a listing, business or broadcast report may give (31 Oct 2026), shared by the server's
? rules (lib/reports/contentReports.ts, lib/chat/reportChat.ts) and the apps (bbm-android
? core/utils/ContentReports.kt). Change all of them together. Safe to import in the browser:
? nothing here touches the database.

  Each list is about the thing reported, so a report reads as what the user saw. A report gives at
  least one reason (the sheets are multi-pick, like the chat report). Chat messages and profiles
  keep their own list (lib/chat/reportReasons.ts), requirements theirs
  (lib/requirements/reportReasons.ts).

*/

/** Reporting another business's listing. */
export const LISTING_REPORT_REASONS: Array<string> = [
	"Fake or misleading listing",
	"Wrong price or details",
	"Already sold or rented",
	"Duplicate listing",
	"Inappropriate photos or content",
	"Something else",
];

/** Reporting a business (a claimant, or the poster of a claimed requirement). */
export const BUSINESS_REPORT_REASONS: Array<string> = [
	"Fake or impersonating business",
	"Fraud or scam",
	"Spam",
	"Harassment or abusive behavior",
	"Inappropriate name or photo",
	"Something else",
];

/** Reporting a broadcast card. */
export const BROADCAST_REPORT_REASONS: Array<string> = [
	"Spam or irrelevant",
	"Fake or misleading listing",
	"Wrong price or details",
	"Inappropriate content",
	"Something else",
];

/** The reasons in [value] that are in [allowed], deduplicated, in [allowed]'s order; empty when none is. */
export function pickReportReasons(value: any, allowed: Array<string>): Array<string> {
	const given = new Set<string>(Array.isArray(value) ? value.map((v: any) => String(v).trim()) : []);
	return allowed.filter((reason) => given.has(reason));
}
